<template>
  <v-card>
    <new-klent
    v-if="add_klent_com"
    v-on:save_klent_success="save_klent_success"
    v-on:save_klent_error="save_klent_error"
    v-on:close_klent="close_klent"
    ></new-klent>


    <v-card-text>
        <v-data-table
            :headers="headers"
            :items="klents"
            :search="search"
            :loading="loading"
                  loading-text="Загрузка. Пожалуйста подождите"
                    :footer-props="{
                        'items-per-page-options': [ 7, 20, 50, 100],
                        'items-per-page-text':'Строк на странице',
                    }"
                    no-data-text="Данные отсутствуют в таблице"
            class="elevation-1"
        >
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Клиенты</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>
                    <v-btn
                     color="primary"
                     @click="add_klent_com = true"
                     dark
                     class="mb-2">
                        Добавить
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Поиск"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="edit_klent(item)">
                    mdi-pencil
                </v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary"  text @click="get_klents">
                    Загрузить
                </v-btn>
            </template>
        </v-data-table>



        <v-dialog
        v-model="edit_klent_dialog"
        max-width="400"
        @click:outside="close_add_klent"
      >
        <v-card>
          <v-card-title class="text-h5">
            Редактирование клиента
          </v-card-title>

          <v-card-text>
            <v-text-field
                v-model="klent.fio"
                label="Имя"
                required
                :rules="nameRules"
            ></v-text-field>

            <v-text-field
            v-model="klent.tel"
            label="Телефон"
            :rules="phoneRules"
            ></v-text-field>

            <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="klent.zodruz"
                label="Дата рождения"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="klent.zodruz"
              :active-picker.sync="activePicker"
              :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
              min="1950-01-01"
              @change="save_date"
              hide-details="auto"
            ></v-date-picker>
          </v-menu>

            <v-text-field
                v-model="klent.kurb"
                label="Валюта"
                disabled
            ></v-text-field>


                <v-select
                :items="bonus_namud"
                v-model="klent.id_namud_karta"
                item-text="text"
                item-value="value"
                label="Тип бонусной карты"
                ></v-select>

                <v-text-field v-if="klent.id_namud_karta > 0"
                v-model="klent.hash_karta"
                label="Номер бонусной карты"
                :rules="[v => !!v || 'Введите номер бонусной карты']"
                ></v-text-field>

                <v-switch
                v-model="klent.holat"
                :label="klent.holat ==1 ? 'Активный' : 'Не активный'"
              ></v-switch>

          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="error darken-1"
              text
              @click="close_add_klent"
            >
              Отмена
            </v-btn>

            <v-btn
              color="green darken-1"
              text
              @click="change_klent"
              :loading="loading"
              :disabled="klent.hash_karta == '' && klent.id_namud_karta > 0"
            >
              Изменить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

        <v-snackbar
        v-model="snack"
        :timeout="3000"
        :color="snackColor"
      >
        {{ snackText }}

        <template v-slot:action="{ attrs }">
          <v-btn
            v-bind="attrs"
            text
            @click="snack = false"
          >
            Закрыть
          </v-btn>
        </template>
      </v-snackbar>

    </v-card-text>
  </v-card>
</template>

<script>
export default {

    data: () => ({

        snack: false,
        snackColor: '',
        snackText: '',
        add_klent_com: false,

        search: '',
        loading: false,

        bonus_namud: [
        { text: 'Нет', value: 0},
        { text: 'Обычный', value: 1},
        { text: 'По каджой покупки', value: 2},
        { text: 'Месячное', value: 3}

        ],

        phoneRules: [
            v => !!v || 'Поле обязательно для заполнения',
            v=> (v && v.length >= 9) || 'Номер должен быть не менее 9 символов',
            v => (v && /^\d+$/.test(v)) || 'Неверный формат номера телефона',
            v => (v && v.length == 9) || 'Неверный формат номера телефона',

        ],

        nameRules: [
            v => !!v || 'Поле обязательно для заполнения',
            v=> (v && v.length >= 3) || 'Название должно быть не менее 3 символов',

        ],

        headers: [
            {
                text: '№',
                align: 'start',
                sortable: false,
                value: 'id_klent',
            },
            { text: 'Имя', value: 'fio' },
            { text: 'Валюта', value: 'kurb' },
            { text: 'Телефон', value: 'tel' },
            { text: 'Дата рождения', value: 'zodruz' },
            { text: 'Тип бонус', value: 'namud_karta'},
            { text: 'Действия', value: 'actions', sortable: false },
        ],
        klents: [],
        klent: {},
        edit_klent_dialog: false,
        activePicker: null,
            menu: false,
    }),

    mounted() {
        this.get_klents();
    },
    methods: {

        get_klents() {
            this.loading = true;
            axios.get('/api/get_klents',
                    {
                        headers: {
                            "Content-type": "application/json"
                        }
                    })
                    .then(response => {
                            if(response.data.status){
                                this.loading = false;
                                this.klents = response.data.klents;
                            }else{
                                this.loading = false;
                                this.snack = true
                                this.snackColor = 'error'
                                this.snackText = "Ошибка получения клиентов"
                                setTimeout(() => {
                                    this.snack = false;
                                }, 2000);
                            }
                        })
                        .catch(error => {
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = error.response.data.message;
                                setTimeout(() => {
                                    this.snack = false;
                                }, 2000);
                        });
        },

        save_klent_success(){
            this.add_klent_com = false;
            this.get_klents();
            this.snack = true
            this.snackColor = 'success'
            this.snackText = "Клиент успешно сохранен"
        },
        save_klent_error(){
            this.add_klent_com = false;
            this.snack = true
            this.snackColor = 'error'
            this.snackText = "Ошибка сохранения клиента"
        },
        close_klent(){
            this.add_klent_com = false;
        },

        edit_klent(item){
            this.edit_klent_dialog = true;
            this.klent = item;
        },

        change_klent(){

            if(this.klent.fio.length > 3 ){



               this.loading = true;
            axios.post('/api/change_klent', this.klent,
                    {
                        headers: {
                            "Content-type": "application/json"
                        }
                    })
                    .then(response => {
                            if(response.data.status){
                                this.loading = false;
                                this.edit_klent_dialog = false;
                                this.snack = true
                                this.snackColor = 'success'
                                this.snackText = "Клиент успешно изменен"

                                this.close_add_klent();
                                setTimeout(() => {
                                    this.snack = false;
                                }, 2000);

                            }else{
                                this.loading = false;
                                this.snack = true
                                this.snackColor = 'error'
                                this.snackText = "Ошибка изменения клиента"
                                setTimeout(() => {
                                    this.snack = false;
                                }, 2000);
                            }
                        })
                        .catch(error => {
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = error.response.data.message;
                            
                                setTimeout(() => {
                                    this.snack = false;
                                }, 2000);
                        });
            }else{
                this.snack = true
                this.snackColor = 'error'
                this.snackText = "Проверьте правильность ввода"
                setTimeout(() => {
                    this.snack = false;
                }, 2000);
            }


        },

        save_date (date) {
        this.$refs.menu.save(this.klent.zodruz)
        },

        close_add_klent(){
            this.edit_klent_dialog = false;
            this.klent = {};
            this.get_klents();
        },



    }
}
</script>

<style>

</style>






